<template>
  <div>
    <!-- 客户基础信息 -->
    <h2>
      {{ $t('message.customerBaseInformation') }}
    </h2>
    <!-- 客户账号信息 -->
    <div class="row">
      <div class="item">
        <!-- 客户账号信息 -->
        <div class="head">
          {{ $t('message.customerAccountInformation') }}:
        </div>
        <!-- 客户头像 -->
        <div class="items userPic">
          <div class="label">
            {{ $t('message.customerProfilePicture') }}:
          </div>
          <div class="val">
            <img :src="detail.portrait_url" alt="">
          </div>
        </div>
        <!-- 注册时间 -->
        <div class="items">
          <div class="label">
            {{ $t('message.registrationDate') }}:
          </div>
          <div class="val">
            {{ detail.created_at }}
          </div>
        </div>
        <!-- 上次访问时间 -->
        <div class="items">
          <div class="label">
            {{ $t('message.lastAccessTime') }}:
          </div>
          <div class="val">
            {{ detail.last_login_at }}
          </div>
        </div>
        <!-- 系统ID -->
        <div class="items">
          <div class="label">
            {{ $t('message.SystemID') }}:
          </div>
          <div class="val">
            {{ detail.id }}
          </div>
        </div>
      </div>
      <div class="item">
        <div class="head noBorder">
        </div>
        <div class="items userPic">
          <div class="label">
          </div>
          <div class="val">
          </div>
        </div>
        <!-- 系统登录名 -->
        <div class="items">
          <div class="label">
            {{ $t('message.systemLoginName') }}:
          </div>
          <div class="val">
            {{ detail.username }}
          </div>
        </div>
        <!-- 全名（真名） -->
        <div class="items">
          <div class="label">
            {{ $t('message.fullName') }}:
          </div>
          <div class="val">
            {{ detail.realname }}
          </div>
        </div>
        <!-- 邮箱 -->
        <div class="items">
          <div class="label">
            {{ $t('message.email') }}:
          </div>
          <div class="val">
            {{ detail.email }}
            <!--  邮件发送-->
            <el-button type="primary" size="mini" @click='$refs.mailSending.dialogVisible = true'>
              {{ $t('message.mailSending') }}
            </el-button>
          </div>
        </div>


      </div>
      <div class="item">
        <div class="head noBorder">
        </div>
        <div class="items userPic">
          <div class="label">
          </div>
          <div class="val">
          </div>
        </div>
        <!-- 手机号 -->
        <div class="items">
          <div class="label">
            {{ $t('message.cellphoneNumber') }}:
          </div>
          <div class="val">
            {{ detail.mobile }}
          </div>
        </div>
        <!--电话号码 -->
        <div class="items">
          <div class="label">
            {{ $t('message.telephoneNumber') }}:
          </div>
          <div class="val">
            {{ detail.tel }}
          </div>
        </div>
        <!-- 账号类别 -->
        <div class="items">
          <div class="label">
            {{ $t('message.typeOfAccount') }}:
          </div>
          <div class="val">
            主账号
            <!-- {{ detail.last_login_at }} -->
          </div>
        </div>
        <!-- 账号状态 -->
        <div class="items">
          <div class="label">
            {{ $t('message.accountStatus') }}:
          </div>
          <div class="val">
            {{ detail.account_status }}
          </div>
        </div>
      </div>
      <div class="item">
        <!-- 日本事务所备注 -->
        <div class="head">
          {{ $t('message.notesFromJapaneseAccountingFirms') }}:
        </div>
        <div class="items remark">
          <el-input type="textarea" :disabled="!isAuth(561)" v-model="detail.japanfirm_remark" resize="none"
            @blur="updateJapanfirmRemark"></el-input>
        </div>
      </div>
    </div>
    <!-- 会员等级: -->
    <div class="row">
      <div class="item">
        <!-- 会员等级 -->
        <div class="head">
          {{ $t('message.membershipLevel') }}:
        </div>
        <!-- 客户等级 -->
        <div class="items ">
          <div class="label">
            {{ $t('message.clientGrade') }}:
          </div>
          <div class="val">
            {{ detail.level_name }}
          </div>
        </div>
        <!-- 手续费比例 -->
        <div class="items">
          <div class="label">
            {{ $t('message.commissionRate') }}:
          </div>
          <div class="val">
            {{ (detail.service_rate * 100).toFixed(2) }}
          </div>
        </div>
        <!-- 客户属性 -->
        <div class="items">
          <div class="label">
            {{ $t('message.customerProperty') }}:
          </div>
          <div class="val">
            {{ detail.is_vip === 1 ? "VIP" : "普通客户" }}
          </div>
        </div>


      </div>
      <div class="item">
        <div class="head noBorder">
        </div>
        <!-- 介绍讲师 -->
        <div class="items">
          <div class="label">
            {{ $t('message.introductionLecturer') }}:
          </div>
          <div class="val">
            {{ detail.gk_realname }}
          </div>
        </div>
        <!-- 人工设置优惠到期 -->
        <div class="items">
          <div class="label">
            {{ $t('message.newCustomerOfferExpires') }}:
          </div>
          <div class="val">
            {{ detail.discount_end_at }}
          </div>
        </div>
        <!-- 定额会员 -->
        <div class="items">
          <div class="label">
            {{ $t('message.quotaMember') }}:
          </div>
          <div class="val">
            {{ detail.is_pay_vip_now ? "是" : "否" }}
          </div>
        </div>
      </div>
      <div class="item">
        <div class="head noBorder">
        </div>

        <!-- 当前账户余额(円) -->
        <div class="items">
          <div class="label">
            {{ $t('message.currentAccountBalance_yen') }}:
          </div>
          <div class="val">
            {{ detail.balance }}
          </div>
        </div>
        <!--累计商品金额(円) -->
        <div class="items">
          <div class="label">
            {{ $t('message.accumulatedValueOfTheProduct_yen') }}:
          </div>
          <div class="val">
            {{ detail.goods_amount }}
          </div>
        </div>
        <!-- 授权欠费额度(円) -->
        <div class="items">
          <div class="label">
            {{ $t('message.authorizeArrears_yen') }}:
          </div>
          <div class="val">
            {{ detail.credit }}
          </div>
        </div>
        <!-- 会员到期日期 -->
        <div class="items">
          <div class="label">
            {{ $t('message.expirationDateOfMembership') }}:
          </div>
          <div class="val">
            {{ detail.pay_vip_end }}({{ detail.pay_vip_end_days }}天)
          </div>
        </div>
      </div>
      <div class="item">
        <!-- 运营备注 -->
        <div class="head ">
          {{ $t('message.userRamrk') }}:
        </div>
        <div class="items remark">
          <el-input type="textarea" readonly v-model="detail.desc" resize="none"></el-input>
        </div>
      </div>
    </div>
    <!-- 客户分配: -->
    <div class="row">
      <div class="item">
        <!-- 客户分配 -->
        <div class="head">
          {{ $t('message.customerAllocation') }}:
        </div>
        <!-- 部门 -->
        <div class="items ">
          <div class="label">
            {{ $t('message.department') }}:
          </div>
          <div class="val">
            {{ detail.client_depart_class }}
          </div>
        </div>
        <!-- 业务员 -->
        <div class="items">
          <div class="label">
            {{ $t('message.salesman') }}:
          </div>
          <div class="val">
            {{ detail.y_realname }}
          </div>
        </div>
        <!-- 采购员 -->
        <div class="items">
          <div class="label">
            {{ $t('message.distributionMember') }}:
          </div>
          <div class="val">
            {{ detail.g_realname }}
          </div>
        </div>
        <!-- 配货员 -->
        <div class="items">
          <div class="label">
            {{ $t('message.buyer') }}:
          </div>
          <div class="val">
            {{ detail.p_realname }}
          </div>
        </div>
      </div>
      <div class="item">
        <!-- 授权状态 -->
        <div class="head ">
          {{ $t('message.authorizationStatus') }}:
        </div>
        <!-- 装箱授权 -->
        <div class="items">
          <div class="label">
            {{ $t('message.packingAuthorization') }}:
          </div>
          <div class="val">
            {{ detail.authorized ? $t('message.authorized') : $t('message.noAuthorized') }}
          </div>
        </div>
        <!-- 入金授权 -->
        <div class="items">
          <div class="label">
            {{ $t('message.goldenAuthorization') }}:
          </div>
          <div class="val">
            {{ detail.is_pay_authorized ? $t('message.authorized') : $t('message.noAuthorized') }}
          </div>
        </div>
        <!-- API绑定标识 -->
        <div class="items">
          <div class="label">
            {{ $t('message.apiBindingIdentifier') }}:
          </div>
          <div class="val">
            <img src="@/assets/img/Amazon.png" alt="" style="width: 80px;height: auto;
            border-radius: 0;" v-if="detail.is_bind_amazon" />
          </div>
        </div>
      </div>
      <div class="item">
        <!-- 聊天 -->
        <div class="head ">
          {{ $t('message.chat') }}:
        </div>
        <!-- 聊天工具-->
        <div class="items">
          <div class="label">
            {{ $t('message.chatTools') }}:
          </div>
          <div class="val">
            <img src="@/assets/user/CW.svg" alt="" v-if="detail.chatwork" />
            <img src="@/assets/user/raku.svg" alt="" v-else />
          </div>
        </div>
        <!--最新聊天时间 -->
        <div class="items">
          <div class="label">
            {{ $t('message.accumulatedValueOfTheProduct_yen') }}:
          </div>
          <div class="val">
          </div>
        </div>
        <!-- 三类订单分别展示最新加单时间。 -->
        <div class="items">
          <div class="label">
            {{ $t('message.latestDaigouOrderTime') }}:
          </div>
          <div class="val">
            {{ detail.last_order_at_dg || '-' }}
          </div>
        </div>
        <div class="items">
          <div class="label">
            {{ $t('message.latestOemOrderTime') }}:
          </div>
          <div class="val">
            {{ detail.last_order_at_oem || '-' }}
          </div>
        </div>
        <div class="items">
          <div class="label">
            {{ $t('message.latestSmallOrderTime') }}:
          </div>
          <div class="val">
            {{ detail.last_order_at_2c || '-' }}
          </div>
        </div>
      </div>
      <div class="item">
        <!-- 客户备注 -->
        <div class="head">
          {{ $t('message.userBeikao') }}:
        </div>
        <div class="items remark">
          <el-input type="textarea" readonly v-model="detail.y_remark" resize="none"></el-input>
        </div>
      </div>
    </div>
    <!-- 发送邮件 -->
    <mailSending :id="detail.id" ref="mailSending" />
  </div>
</template>
<script>
import mailSending from './mailSending'
export default {
  props: {
    detail: { type: Object }
  },
  components: {
    mailSending
  },
  data() {
    return {

    };
  },
  created() {

  },
  methods: {
    updateJapanfirmRemark() {
      let datas = {
        user_id: this.detail.id,
        japanfirm_remark: this.detail.japanfirm_remark,
      }
      this.$api.JapaneseOffice.updateJapanfirmRemark(datas).then(res => {
        this.$message.success(res.msg)
      })
    }
  }
}
</script>
<style lang='scss' scoped>
h2 {
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #EDEFF4;
  font-size: 18px;
  font-weight: bold;
  margin-top: 24px;

}

.row {
  display: flex;

  .item {
    flex: 1;

    .head {
      margin-bottom: 24px;
      font-weight: bold;
      border-left: 2px solid #B4272d;
      height: 16px;
      line-height: 16px;
      padding-left: 8px;
      margin: 22px 0;
    }

    .noBorder {
      border: 0;
    }

    .items {
      display: flex;
      margin-bottom: 22px;

      .label {
        flex: 1;
        text-align: right;
        margin-right: 16px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }

      .val {
        flex: 2;
        align-items: center;

        img {
          width: 41px;
          height: 41px;
          border-radius: 50%;
        }
      }
    }

    .userPic {
      height: 41px;
    }
  }
}

/deep/.el-textarea__inner {
  width: 320px;
  height: 120px;
}

/deep/.is-disabled {
  .el-textarea__inner {
    background-color: #fff;
    color: #606266
  }

}
</style>
